/* YouDib : ajoute le texte saisi par le client comme propriete visible du panier */
(function () {
  var LABEL = 'Ton texte';

  function readText() {
    var parts = [];
    var fields = document.querySelectorAll('.tee-field--text');
    for (var i = 0; i < fields.length; i++) {
      var input = fields[i].querySelector('input[type="text"], textarea');
      if (!input) continue;
      var v = (input.value || '').trim();
      if (v) parts.push(v);
    }
    return parts.join(' ');
  }

  function decorate(props) {
    var t = readText();
    if (!t) return props;
    props = props || {};
    props[LABEL] = t;
    return props;
  }

  function decorateObject(o) {
    if (!o || typeof o !== 'object') return o;
    if (Array.isArray(o.items)) {
      for (var i = 0; i < o.items.length; i++) {
        o.items[i].properties = decorate(o.items[i].properties);
      }
    } else if (o.id || o.quantity) {
      o.properties = decorate(o.properties);
    }
    return o;
  }

  function isAddUrl(u) {
    return typeof u === 'string' && u.indexOf('/cart/add') !== -1;
  }

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (isAddUrl(url) && init && init.body) {
          var b = init.body;
          if (typeof b === 'string') {
            var s = b.trim();
            if (s.charAt(0) === '{') {
              var o = JSON.parse(s);
              init = Object.assign({}, init, { body: JSON.stringify(decorateObject(o)) });
            } else {
              var t = readText();
              if (t && s.indexOf('properties%5B' + encodeURIComponent(LABEL)) === -1) {
                init = Object.assign({}, init, {
                  body: s + '&' + encodeURIComponent('properties[' + LABEL + ']') + '=' + encodeURIComponent(t)
                });
              }
            }
          } else if (typeof FormData !== 'undefined' && b instanceof FormData) {
            var t2 = readText();
            if (t2 && !b.has('properties[' + LABEL + ']')) b.append('properties[' + LABEL + ']', t2);
          }
        }
      } catch (e) {}
      return origFetch.apply(this, [input, init]);
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ydAdd = isAddUrl(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__ydAdd && body) {
        if (typeof body === 'string') {
          var s = body.trim();
          if (s.charAt(0) === '{') {
            body = JSON.stringify(decorateObject(JSON.parse(s)));
          } else {
            var t = readText();
            if (t && s.indexOf('properties%5B' + encodeURIComponent(LABEL)) === -1) {
              body = s + '&' + encodeURIComponent('properties[' + LABEL + ']') + '=' + encodeURIComponent(t);
            }
          }
        } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
          var t3 = readText();
          if (t3 && !body.has('properties[' + LABEL + ']')) body.append('properties[' + LABEL + ']', t3);
        }
      }
    } catch (e) {}
    return origSend.call(this, body);
  };
})();
